module.exports = __webpack_public_path__ + "static/img-main-cd41820a134465c759315f9fc1bb06b9.jpg";